import {
    CALL_SNOWFLAKE_STORED_PROCEDURE,
    LOAD_SNOWFLAKE_TABLE,
    UNLOAD_SNOWFLAKE_TABLE,
    RUN_FULL_MATERIALIZATION
} from 'app/lib/types/server';

export const JOB_TYPE_I18N = {
    [CALL_SNOWFLAKE_STORED_PROCEDURE]: 'storedProcedure',
    [LOAD_SNOWFLAKE_TABLE]: 'importFromCloud',
    [UNLOAD_SNOWFLAKE_TABLE]: 'exportToCloud',
    [RUN_FULL_MATERIALIZATION]: 'modelJob'
};
